import React from "react";
import PropTypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

import { StudentHeroWrapper } from "./style";

const StudentHero = (props) => {
	const {
		heading,
		courseTrack,
		beforeSpringboard,
		afterSpringboard,
		testimonial,
		studentImage,
		logoImage,
	} = props;

	return (
		<StudentHeroWrapper>
			<div className="container">
				<div className="content">
					<div className="courseTrack">{courseTrack}</div>
					<div
						className="heading"
						dangerouslySetInnerHTML={{
							__html: heading,
						}}
					></div>
					<div>
						<CloudinaryImage
							lazyload
							url={logoImage}
							sizes={{ default: { height: 92 } }}
						/>
					</div>
					<div className="jobDesignation">
						<div className="designationTitle">Before Springboard:</div>
						<div className="designation">{beforeSpringboard}</div>
					</div>
					<div className="jobDesignation">
						<div className="designationTitle">After Springboard:</div>
						<div className="designation">{afterSpringboard}</div>
					</div>
					<div className="testimonial">{testimonial}</div>
				</div>
				<div className="image">
					<CloudinaryImage
						lazyload
						url={studentImage}
						sizes={{ default: { height: 397 }, 1024: { height: 219 } }}
					/>
				</div>
			</div>
			<div className="testimonialTab">{testimonial}</div>
		</StudentHeroWrapper>
	);
};

StudentHero.propTypes = {
	heading: PropTypes.string,
	courseTrack: PropTypes.string,
	beforeSpringboard: PropTypes.string,
	afterSpringboard: PropTypes.string,
	testimonial: PropTypes.string,
	studentImage: PropTypes.string,
	logoImage: PropTypes.string,
};

StudentHero.defaultProps = {
	heading: "",
	courseTrack: "",
	beforeSpringboard: "",
	afterSpringboard: "",
	testimonial: "",
	studentImage: "",
	logoImage: "",
};

export default StudentHero;
